import React from 'react'

interface StepperSelectedProps {
    fill?: string
    stroke?: string
}

/**
 * SVG icon for completed steps in the Stepper component
 */
const StepperSelected: React.FC<StepperSelectedProps> = ({
    fill = '#36c',
    stroke = '#fff'
}) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        fill={fill}
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        className='lucide lucide-circle-check-big w-5 h-5'
        viewBox='0 0 24 24'
    >
        <path d='M21.801 10A10 10 0 1 1 17 3.335' stroke={stroke}></path>
        <path d='m9 11 3 3L22 4' stroke={stroke}></path>
    </svg>
)

export default StepperSelected
